<template>
  <div>
    <div class="card-background">
      <p class="sub-heading-text">Approved Business Categories</p>
      <!-- <w-partner-table
        :tableValue="businessCategoryApprovedList"
        :tableLoading="showTableLoding"
        :filter="businessCategoryFilterText"
        :typeOfTable="'ApprovedBusinessCategoryTable'"
      />-->
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col" style="width:20%">Partner Type</th>
            <th scope="col" style="width:30%">Categories</th>
            <th scope="col" style="width:40%">Sub-Categories</th>
            <th scope="col" style="width:10%">Approved On</th>
          </tr>
        </thead>
        <tbody class="text-left">
          <tr v-for="(item,i) in businessCategoryApprovedList.items" :key="i">
            <td scope="col" style="width:20%">{{item.categoryName}}</td>
            <td scope="col" style="width:30%">
              <ol v-for="(cat,ic) in item.categories" :key="ic" :start="(ic+1)">
                <li>{{cat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:40%">
              <ol v-for="(subCat,isc) in item.subCategories" :key="isc" :start="(isc+1)">
                <li>{{subCat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:10%">{{approvedBusinessCategories[i].approvedDate}}</td>
          </tr>
          <tr v-if="businessCategoryApprovedList.items.length == 0">
            <td colspan="11" class="m-0 p-0">
              <div class="m-0 p-3 text-center">No Records found</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <div class="card-background">
      <p class="sub-heading-text">Rejected Business Categories</p>
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col" style="width:20%">Partner Type</th>
            <th scope="col" style="width:30%">Categories</th>
            <th scope="col" style="width:40%">Sub-Categories</th>
            <th scope="col" style="width:10%">Rejected On</th>
          </tr>
        </thead>
        <tbody class="text-left">
          <tr v-for="(item,i) in rejectedBusinessCategories" :key="i">
            <td scope="col" style="width:20%">{{item.partnerTypeDesc}}</td>
            <td scope="col" style="width:30%">
              <ol v-for="(cat,ic) in item.categories" :key="ic" :start="(ic+1)">
                <li>{{cat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:40%">
              <ol v-for="(subCat,isc) in item.subCategories" :key="isc" :start="(isc+1)">
                <li>{{subCat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:10%">{{item.actionDate}}</td>
          </tr>
          <tr v-if="rejectedBusinessCategories.length == 0">
            <td colspan="11" class="m-0 p-0">
              <div class="m-0 p-3 text-center">No Records found</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <br />
    <div class="card-background">
      <p class="sub-heading-text">New Business Categories</p>
      <!-- <w-partner-table
        :tableValue="bcTableDataList"
        :tableLoading="showTableLoding"
        :filter="businessCategoryFilterText"
        :typeOfTable="'businessCategoryTableSummary'"
      />-->
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th scope="col" style="width:20%">Partner Type</th>
            <th scope="col" style="width:30%">Categories</th>
            <th scope="col" style="width:40%">Sub-Categories</th>
            <th scope="col" style="width:10%">Created On</th>
          </tr>
        </thead>
        <tbody class="text-left">
          <tr v-for="(item,i) in bcTableDataList.items" :key="i">
            <td scope="col" style="width:20%">{{item.partnerTypeDesc}}</td>
            <td scope="col" style="width:30%">
              <ol v-for="(cat,ic) in item.categories" :key="ic" :start="(ic+1)">
                <li>{{cat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:40%">
              <ol v-for="(subCat,isc) in item.subCategories" :key="isc" :start="(isc+1)">
                <li>{{subCat.categoryName}}</li>
              </ol>
            </td>
            <td scope="col" style="width:10%">{{item.actionDate}}</td>
          </tr>
          <tr v-if="bcTableDataList.items.length == 0">
            <td colspan="11" class="m-0 p-0">
              <div class="m-0 p-3 text-center">No Records found</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();
import partnertable from "../../widgets/partner-table";
import LoadingSpinner from "../../widgets/LoadingSpinner";

export default {
  props: ["answerNumber"],
  components: {
    "w-partner-table": partnertable,
    "w-loading-spinner": LoadingSpinner
  },
  data() {
    return {
      enableSubmit: true,
      businessCategoryFilterText: "",
      approvedBusinessCategories: [],
      rejectedBusinessCategories: [],
      newBusinessCategories: [],
      businessCategoryApprovedList: {
        fields: [
          {
            key: "partnerTypeABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "categoriesABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "subCategoriesABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      bcTableDataList: {
        fields: [
          {
            key: "partnerTypeNABC",
            label: "Partner Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "categoriesNABC",
            label: "Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "subCategoriesNABC",
            label: "Sub Categories",
            thClass: "thClassLeft",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      loading: false
    };
  },
  watch: {},
  created() {
    this.getPartnerApprovedBusinessCategory();
    // this.getBusinessCategoryDetails();
  },
  computed: {},
  methods: {
    getPartnerApprovedBusinessCategory() {
      this.loading = true;
      this.businessCategoryApprovedList.items = [];
      SummaryService.getPartnerApprovedBusinessCategories(this.answerNumber)
        .then(res => {
          if (res) {
            for (let i = 0; i < res.response.length; i++) {
              this.businessCategoryApprovedList.items.push(
                res.response[i].businessDetails
              );
              this.approvedBusinessCategories.push(res.response[i]);
            }
            // this.loading = false;
            console.log(this.approvedBusinessCategories);
            this.getPartnerRejectedBusinessCategory();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBusinessCategoryDetails() {
      SummaryService.getBusinessCategories(this.answerNumber)
        .then(res => {
          if (res) {
            this.bcTableDataList.items.push(res.response);
            this.loading = false;
            console.log(this.bcTableDataList.items);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPartnerRejectedBusinessCategory() {
      SummaryService.getPartnerRejectedBusinessCategories(this.answerNumber)
        .then(res => {
          if (res) {
            for (let i = 0; i < res.response.length; i++) {
              this.rejectedBusinessCategories.push(res.response[i]);
            }
            console.log(this.rejectedBusinessCategories);
            this.getBusinessCategoryDetails();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
</style>
<style>
.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
</style>